import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=f9e3f89a"
import script from "./ComponentsList.vue?vue&type=script&lang=js"
export * from "./ComponentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports